import React, { useState } from 'react';
import './FlyoutContentWithFooter.scss';
import FlyoutFooter from './FlyoutFooter';
import FlyoutContent from './FlyoutContent';
// import PagesSlider from './PagesSlider';
// import pagesSliderData from './pagesSliderdata.json';

const FlyoutContentWithFooter = (props) => {
  // const [contentShow, setcontentShow] = useState(props.option);
  // const buttonsList = pagesSliderData['buttons-list'];
  // const content = props.content.find(item => item.id === contentShow);
  const { content, Modal } = props;
  return (
    <div>
      {/* <PagesSlider
        buttonsList={buttonsList}
        setcontentShow={setcontentShow}
        contentShow={contentShow}
      />  */}
      <div className="content-info">
        <FlyoutContent content={content} />
      </div>
      <FlyoutFooter {...content.footer} Modal={Modal} />
    </div>
  );
};

export default FlyoutContentWithFooter;
